import {ProcessClientOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ListingRendererType} from 'nav/expanded/ListingRendererConstants';

import ProcedureMethodTaskListingRenderer from '../procedures/ProcedureMethodTaskListingRenderer';

export default class RecipeUnitOperationTaskListingRenderer extends ProcedureMethodTaskListingRenderer<ListingRendererType.RECIPE_UNIT_OPERATION_TASK> {
  listingRendererType = ListingRendererType.RECIPE_UNIT_OPERATION_TASK;

  constructor() {
    super(ProcessClientOrigin.RECIPES);
  }
}
